import React from 'react';

export default function SearchTab() {
  return (
    <form>
      <input id="search" type="text" />
      <label htmlFor="search">검색</label>
    </form>
  );
}
